// Alpine $store('dossierNav') — tracks the active tab on the wielerploeg dossier
// detail page. Initialised from window.__dossierNavValid / __dossierNavAliases
// (bootstrapped by views/admin/wielerploeg/dossiers/show.php) so the store is
// available during Alpine.start() for elements that may sit outside the outer
// x-data scope due to deep HTML nesting.

document.addEventListener('alpine:init', () => {
    const h = (window.location.hash || '').replace('#', '');
    const valid   = window.__dossierNavValid   || [];
    const aliases = window.__dossierNavAliases || {};
    const resolved = aliases[h] || h;
    const activeTab = (resolved && valid.includes(resolved)) ? resolved : 'overzicht';

    window.Alpine.store('dossierNav', { activeTab });
});
